import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const ParticipationShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    설명회 신청 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    설명회 신청 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* participationColumns.tsx와 동일한 필드/라벨(issue #69: 기존 place/content/startDate/endDate는 실존하지 않는 필드였음) */}
                        <FieldItem label="상태" value={record?.status} />
                        <FieldItem label="학부모 ID" value={record?.parentId} />
                        <FieldItem label="신청한 설명회 ID" value={record?.ptDateId} />
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
